'use client';

import React from 'react';

/**
 * Segment-level error boundary.
 * Catches errors thrown while rendering any page inside the root layout.
 * Dependency-free: no context hooks, dynamic imports, or animation libraries.
 */
export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 16,
                minHeight: '60vh',
                padding: 24,
                textAlign: 'center',
            }}
        >
            <h2 style={{ fontSize: '1.4rem', fontWeight: 700 }}>This section failed to load</h2>
            <p style={{ opacity: 0.7 }}>Something went wrong while displaying this page.</p>
            <button
                onClick={reset}
                style={{
                    padding: '10px 18px',
                    borderRadius: 8,
                    border: 'none',
                    background: '#D6213B',
                    color: '#fff',
                    fontWeight: 700,
                    cursor: 'pointer',
                }}
            >
                Try again
            </button>
            {process.env.NODE_ENV !== 'production' && error?.message && (
                <pre
                    style={{
                        marginTop: 8,
                        textAlign: 'left',
                        fontSize: '0.8rem',
                        whiteSpace: 'pre-wrap',
                        opacity: 0.6,
                        maxWidth: '90vw',
                        overflow: 'auto',
                    }}
                >
                    {error.message}
                </pre>
            )}
        </div>
    );
}
